﻿import React from 'react';
import {Typography} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Typography)(() => ({
  fontSize: '1rem',
  lineHeight: '1.43em',
  letterSpacing: '0.01em',
  fontWeight: 500
}));

type CardItemValueProps = React.ComponentPropsWithoutRef<'span'>

/**
 * MUI Typography component styled in the SecurSpace way. Any of its variations can be used in an ItemContainer in combination
 * with an ItemLabel to create a duo capable of toppling all existence in their styled ways
 * @param children children passed through to the internal Typography component
 * @param rest The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const CardItemValue = ({ children, ...rest}: CardItemValueProps) => {
  return <Root variant={'body1'} {...rest}>
    { children }
  </Root>
}

export { CardItemValue };
